// opervex-frontend/src/pages/Reports/SalesOrder.js

import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import DynamicReport from "../../components/DynamicReport";
import useOpervex from "../../hooks/useOpervex";

const SalesOrder = () => {
  const [schema, setSchema] = useState(null);
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const loadSchema = async () => {
      const result = await OpervexAPI.Report.SalesOrder.schema();
      setSchema(result);
    };

    loadSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!schema)
    return (
      <Container fluid className="text-center mt-5">
        <span>Carregando relatório...</span>
      </Container>
    );

  return (
    <>
      <h1 className="fw-light text-center">Relatório de Ordens de Venda</h1>

      <DynamicReport
        reportName={"reportSalesOrder"}
        urlData={"/Report/SalesOrder"}
        schema={schema}
        links={[{ key: "id", link: "/Sales/SalesOrder/:id", newPage: true }]}
      />
    </>
  );
};

export default SalesOrder;
